export enum ElementType {
    Mortgage = 1,
    Income = 2,
    Tax = 3,
    Fee = 4,
    Expense = 5
}
